import { styled } from '@linaria/react';
import { fonts, layout, semantic, size, space } from '../../theme/tokens';

export const Bar = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  background-color: ${semantic.bg.canvas};
  background-image: linear-gradient(${semantic.bg.surfaceSubtle}, ${semantic.bg.surfaceSubtle});
  padding: ${space['space-400']} ${space['space-1200']};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};

  @media (max-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-300']} ${space['space-900']};
    font-size: ${fonts.size.xs};
  }
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-100']};
  min-width: 0;
`;

export const Content = styled.div`
  &[data-clamped='true'] {
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  & p {
    margin: 0;
  }

  & strong {
    font-weight: ${fonts.weight.semiBold};
  }

  & a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const Heading = styled.span`
  font-weight: ${fonts.weight.semiBold};
  margin-right: ${space['space-200']};
`;

export const Dismiss = styled.button`
  position: absolute;
  top: 50%;
  right: ${space['space-300']};
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space['space-100']};
  color: ${semantic.text.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

export const Toggle = styled.button`
  background: none;
  border: none;
  min-height: ${space['space-600']};
  padding: 0 ${space['space-100']};
  cursor: pointer;
  font: inherit;
  font-weight: ${fonts.weight.semiBold};
  color: inherit;
  text-decoration: underline;

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
    border-radius: ${space['space-050']};
  }
`;
